import { gql } from '@apollo/client';

/**
 * 查询账单重跑进度
 */
export const GET_BILL_RERUN_PROGRESS = gql`
  query GetBillRerunProgress($taskId: ID!) {
    getBillRerunProgress(taskId: $taskId) {
      taskId
      status
      progress
      currentStep
      periodInstanceId
      clientId
      clientName
      billType
      periodStart
      periodEnd
      timeZone
      reason
      originalBillId
      newBillId
      errorMessage
      createdAt
      completedAt
    }
  }
`;

/**
 * 查询账单重跑历史
 */
export const GET_BILL_RERUN_HISTORY = gql`
  query GetBillRerunHistory($clientId: ID!) {
    getBillRerunHistory(clientId: $clientId) {
      taskId
      status
      progress
      currentStep
      periodInstanceId
      clientId
      clientName
      billType
      periodStart
      periodEnd
      timeZone
      reason
      originalBillId
      newBillId
      errorMessage
      createdAt
      completedAt
    }
  }
`;

